const isVehicleDeclarationShown = () => process.env.REACT_APP_VEHICLE_DECLARATION_SHOW === 'true';

export default isVehicleDeclarationShown;
